/** @format */
import { LocaleState } from "./type";

export const initialState: LocaleState = {
  currentLang: "en",
};
